import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL + '/admin_orders_history';


function getOrdersHistoryList(params) {
    return axios.get(`${url}/list?page=` + params.page + '&per_page=' + params.per_page + '&tab=' + params.tab +  '&default-period=' +JSON.stringify(params.defaultPeriod)  +  '&archive=' + params.archive )
        .then(response => {
            return {
                adminOrdersHistoryList: response.data,
            };
        }).catch(err => {
            return {
                adminOrdersHistoryList: err.response.data.error,
            };
        });
}
function getPaginatedTabOrdersList(params) {
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    const payload = {tab: params.tab, sort_by: params.sort_by, period: params.period};
    return axios.post(`${url}/paginated_tab_list?page=` + params.page + '&per_page=' + params.per_page +  '&archive=' + params.archive, payload, options)
        .then(response => {
            return {
                tadOrdersList: response.data,
            };
        }).catch(err => {
            return {
                tadOrdersList: err.response.data.error,
            };
        });
}
function getTabSearchOrdersList(params) {
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };

    let payload = { tab: params.tab, sort_by: params.sort_by };
    if (params.client_id) {
        payload = { tab: params.tab, sort_by: params.sort_by, client_id: params.client_id };
    }
    return axios.post(`${url}/search_tab_by_order_number/` + params.order_number +'?page=' + params.page + '&per_page=' + params.per_page + '&archive=' + params.archive, payload, options)
        .then(response => {
            return {
                tabSearchOrdersList: response.data,
            };
        }).catch(err => {
            return {
                tabSearchOrdersList: err.response.data.error,
            };
        });
}

function getTabByWorkerPeriod(params) {
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/show_period_by_workers?page=` + params.page + '&per_page=' + params.per_page  + '&archive=' + params.archive, params, options)
        .then(response => {
            return {
                workersTabPeriod: response.data,
            };
        }).catch(err => {
            return {
                workersTabPeriod: err.response.data.error,
            };
        });
}
function getTabHistoryByPeriod(params) {
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/show_orders_history_by_period?page=` + params.page + '&per_page=' + params.per_page + '&archive=' + params.archive, params, options)
        .then(response => {
            return {
                historyByPeriod: response.data,
            };
        }).catch(err => {
            return {
                historyByPeriod: err.response.data.error,
            };
        });
}

function getTabHistoryByStatuses(params) {
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/show_orders_history_by_statuses?page=` + params.page + '&per_page=' + params.per_page + '&archive=' + params.archive, params, options)
        .then(response => {
            return {
                historyByStatuses: response.data,
            };
        }).catch(err => {
            return {
                historyByStatuses: err.response.data.error,
            };
        });
}
function getOrdersHistoryByClientId(params) {
    return axios.get(`${url}/list/` + params.client_id +'?page=' + params.page + '&per_page=' + params.per_page + '&archive=' + params.archive)
        .then(response => {
            return {
                adminOrdersHistoryByClientId: response.data,
            };
        }).catch(err => {
            return {
                adminOrdersHistoryByClientId: err.response.data.error,
            };
        });
}
function getBrokenOrderInfo(params) {
    return axios.get(`${url}/order_broken_info/` + params)
        .then(response => {
            return {
                brokenOrderInfo: response.data,
            };
        }).catch(err => {
            return {
                brokenOrderInfo: err.response.data.error,
            };
        });
}
function getOrderHistoryInfo(order_id, archive) {
     return axios.get(`${url}/order_history_info/${order_id}`, {
        params: { archive }
    })
        .then(response => {
            return {
                orderHistoryInfo: response.data,
            };
        }).catch(err => {
            return {
                orderHistoryInfo: err.response.data.error,
            };
        });
}
function getTabOrdersByClientId(params) {
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    const payload = {tab: params.tab, sort_by: params.sort_by};
    return axios.post(`${url}/paginated_tab_list/` + params.client_id +'?page=' + params.page + '&per_page=' + params.per_page + '&archive=' + params.archive, payload, options)
        .then(response => {
            return {
                tadOrdersListByClientId: response.data,
            };
        }).catch(err => {
            return {
                tadOrdersListByClientId: err.response.data.error,
            };
        });
}

export default {
    getOrdersHistoryList,
    getOrdersHistoryByClientId,
    getPaginatedTabOrdersList,
    getTabOrdersByClientId,
    getBrokenOrderInfo,
    getOrderHistoryInfo,
    getTabSearchOrdersList,
    getTabByWorkerPeriod,
    getTabHistoryByPeriod,
    getTabHistoryByStatuses
};